import { useSearchParams } from "react-router-dom";
import JitsiComponent from "../JitsiComponent/JitsiComponent";

interface MeetingRoomProps {
    sessionHistoryId: string;
    jitsiToken: string;
    email: string;
    userId: string;
    providerName: string;
}

export default function MeetingRoom({
    jitsiToken,
    sessionHistoryId,
    email,
    userId,
    providerName,
}: MeetingRoomProps) {
    const [searchParams] = useSearchParams();
    const clientName = searchParams.get("with") ?? "";

    return (
        <div className="h-dvh bg-[#fbfbfb] overflow-y-hidden flex flex-col">
            <div className="h-[8dvh] flex items-center px-24 text-lg shrink-0">
                Session with
                <span className="capitalize inline-block ml-1 font-semibold">
                    {clientName.replaceAll("_", " ")}
                </span>
            </div>
            <div className="flex-1 min-h-0 relative">
                <JitsiComponent
                    providerEmail={email}
                    providerName={providerName}
                    roomName={sessionHistoryId || ""}
                    token={jitsiToken}
                    userId={userId}
                />
            </div>
        </div>
    );
}
